'use strict'

import HttpClient from './HttpClient'
// import store from '../../store'

class Profile extends HttpClient {
  searchPublicProfile (data) {
    var url = '/api/public/search/company/profile'

    return this.sendPost(url, {}, data)
  }
  getPublicProfile (id) {
    var url = '/api/public/company/profile/info/get/' + id

    return this.sendGet(url, {})
  }
  getPrivateProfile (id) {
    var url = '/api/private/company/profile/info/get/' + id

    return this.sendGet(url, this.headers)
  }

  getPrivateProfileById (id) {
    var url = '/api/private/company/profile/info/getbyid/' + id

    return this.sendGet(url, this.headers)
  }

  updateCompanyProfile (data) {
    var url = '/api/company/user/profile/update/'

    return this.sendPut(url, this.headers, data)
  }
  addRatingReview (data) {
    var url = '/api/company/add/rating-review'

    return this.sendPost(url, this.headers, data)
  }
  getOneRatingReview (id) {
    var url = '/api/company/get/rating-review/' + id

    return this.sendGet(url, this.headers)
  }
  getListRatingReview (data) {
    var url = '/api/company/getlist/rating-review'

    return this.sendPost(url, this.headers, data)
  }
  updateCompanyInfoViewCount (data) {
    var url = '/api/company/info/update/view-count'

    return this.sendPut(url, this.headers, data)
  }
}

export default Profile
